export default [{
	titulo: 'Serviços',
	icone: 'menu-icon fa fa-caret-right',
	url: '/servicos/servicos',
	visualizar: false,
	actions: [{
		value: false,
		name: 'Cadastrar'
	}, {
		value: false,
		name: 'Editar'
	}, {
		value: false,
		name: 'Apagar'
	}]
}]